"use client";

import { c as _c } from "react/compiler-runtime";
import styles from "./MemeLab.module.scss";
import { useAuth } from "@/components/auth/Auth";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import Download from "@/components/download/Download";
import LatestActivityRow from "@/components/latest-activity/LatestActivityRow";
import MemeLabLeaderboard from "@/components/leaderboard/MemeLabLeaderboard";
import NFTAttributes from "@/components/nft-attributes/NFTAttributes";
import { NftPageStats } from "@/components/nft-attributes/NftStats";
import NFTImage from "@/components/nft-image/NFTImage";
import NFTMarketplaceLinks from "@/components/nft-marketplace-links/NFTMarketplaceLinks";
import NftNavigation from "@/components/nft-navigation/NftNavigation";
import TransferSingle from "@/components/nft-transfer/TransferSingle";
import NothingHereYetSummer from "@/components/nothingHereYet/NothingHereYetSummer";
import Pagination from "@/components/pagination/Pagination";
import { printMemeReferences } from "@/components/rememes/RememePage";
import ArtistProfileHandle from "@/components/the-memes/ArtistProfileHandle";
import { getMemeTabTitle, MEME_FOCUS, MEME_TABS, TabButton } from "@/components/the-memes/MemeShared";
import Timeline from "@/components/timeline/Timeline";
import { publicEnv } from "@/config/env";
import { MEMELAB_CONTRACT, MEMES_CONTRACT, NULL_ADDRESS } from "@/constants";
import { useTitle } from "@/contexts/TitleContext";
import { DBResponse } from "@/entities/IDBResponse";
import { LabExtendedData, LabNFT, NFT, NFTHistory } from "@/entities/INFT";
import { CollectedCollectionType } from "@/entities/IProfile";
import { Transaction } from "@/entities/ITransaction";
import { ContractType } from "@/enums";
import { addProtocol, areEqualAddresses, enterArtFullScreen, fullScreenSupported, numberWithCommas, parseNftDescriptionToHtml, printMintDate } from "@/helpers/Helpers";
import { getDimensionsFromMetadata, getFileTypeFromMetadata } from "@/helpers/nft.helpers";
import { TypeFilter } from "@/hooks/useActivityData";
import useCapacitor from "@/hooks/useCapacitor";
import { fetchAllPages, fetchUrl } from "@/services/6529api";
import { faExpandAlt, faFire } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import { useRouter, useSearchParams } from "next/navigation";
import { Fragment, useEffect, useState } from "react";
import { Carousel, Col, Container, Dropdown, Row, Table } from "react-bootstrap";
const ACTIVITY_PAGE_SIZE = 25;
export default function MemeLabPageComponent(t0) {
  const $ = _c(86);
  const {
    nftId
  } = t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  const capacitor = useCapacitor();
  const {
    connectedProfile
  } = useAuth();
  const {
    country
  } = useCookieConsent();
  const {
    setTitle
  } = useTitle();
  const [isFullScreenSupported, setIsFullScreenSupported] = useState(false);
  const [fullscreenElementId, setFullscreenElementId] = useState("the-art-fullscreen-img");
  const [activeTab, setActiveTab] = useState();
  const [nft, setNft] = useState();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [originalMemes, setOriginalMemes] = useState(t1);
  const [nftMeta, setNftMeta] = useState();
  const [nftBalance, setNftBalance] = useState(0);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [transactions, setTransactions] = useState(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [activity, setActivity] = useState(t3);
  const [userLoaded, setUserLoaded] = useState(false);
  const [originalMemesLoaded, setOriginalMemesLoaded] = useState(false);
  const [activityPage, setActivityPage] = useState(1);
  const [activityTotalResults, setActivityTotalResults] = useState(0);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [nftHistory, setNftHistory] = useState(t4);
  const [activityTypeFilter, setActivityTypeFilter] = useState(TypeFilter.ALL);
  let t5;
  if ($[4] !== activeTab || $[5] !== nft || $[6] !== nftId || $[7] !== setTitle) {
    t5 = () => {
      setTitle(getMemeTabTitle("Meme Lab", nftId, nft, activeTab));
    };
    $[4] = activeTab;
    $[5] = nft;
    $[6] = nftId;
    $[7] = setTitle;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== activeTab || $[10] !== nft || $[11] !== nftId) {
    t6 = [nft, nftId, activeTab];
    $[9] = activeTab;
    $[10] = nft;
    $[11] = nftId;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] !== searchParams) {
    t7 = () => {
      setIsFullScreenSupported(fullScreenSupported());
      let initialFocus = MEME_FOCUS.LIVE;
      const routerFocus = searchParams?.get("focus");
      if (routerFocus) {
        const resolvedRouterFocus = Object.values(MEME_FOCUS).find(sd => sd === routerFocus);
        if (resolvedRouterFocus) {
          initialFocus = resolvedRouterFocus;
        }
      }
      setActiveTab(initialFocus);
    };
    $[13] = searchParams;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  useEffect(t7, t8);
  let t9;
  if ($[16] !== activeTab || $[17] !== router) {
    t9 = () => {
      if (activeTab) {
        const query = {
          focus: activeTab
        };
        router.replace(`?${new URLSearchParams(query).toString()}`);
      }
    };
    $[16] = activeTab;
    $[17] = router;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== activeTab) {
    t10 = [activeTab];
    $[19] = activeTab;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($[21] !== nftId) {
    t11 = () => {
      if (nftId) {
        fetchUrl(`${publicEnv.API_ENDPOINT}/api/lab_extended_data?id=${nftId}`).then(response => {
          const nftMetas = response.data;
          if (nftMetas.length === 1) {
            setNftMeta(nftMetas[0]);
            fetchUrl(`${publicEnv.API_ENDPOINT}/api/nfts_memelab?id=${nftId}`).then(response_0 => {
              const nft_0 = response_0.data[0];
              setNft(nft_0);
              if (nft_0.meme_references.length > 0) {
                fetchUrl(`${publicEnv.API_ENDPOINT}/api/nfts?sort_direction=asc&contract=${MEMES_CONTRACT}&id=${nft_0.meme_references.join(",")}`).then(response_1 => {
                  setOriginalMemes(response_1.data);
                  setOriginalMemesLoaded(true);
                });
              } else {
                setOriginalMemesLoaded(true);
              }
            });
          } else {
            setNftMeta(undefined);
          }
        });
      }
    };
    t12 = [nftId];
    $[21] = nftId;
    $[22] = t11;
    $[23] = t12;
  } else {
    t11 = $[22];
    t12 = $[23];
  }
  useEffect(t11, t12);
  let t13;
  if ($[24] !== connectedProfile?.wallets || $[25] !== nftId) {
    t13 = () => {
      const walletObjects = connectedProfile?.wallets ?? [];
      const wallets = walletObjects.map(_temp);
      if (wallets.length > 0 && nftId) {
        fetchUrl(`${publicEnv.API_ENDPOINT}/api/transactions_memelab?wallet=${wallets.join(",")}&id=${nftId}`).then(response_2 => {
          setTransactions(response_2.data);
          let countIn = 0;
          let countOut = 0;
          response_2.data.map(d => {
            if (wallets.some(w_0 => areEqualAddresses(w_0, d.from_address))) {
              countOut = countOut + d.token_count;
              countOut;
            }
            if (wallets.some(w_1 => areEqualAddresses(w_1, d.to_address))) {
              countIn = countIn + d.token_count;
              countIn;
            }
          });
          setUserLoaded(true);
          setNftBalance(countIn - countOut);
        });
      } else {
        setNftBalance(0);
      }
    };
    $[24] = connectedProfile?.wallets;
    $[25] = nftId;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== connectedProfile || $[28] !== nftId) {
    t14 = [nftId, connectedProfile];
    $[27] = connectedProfile;
    $[28] = nftId;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  useEffect(t13, t14);
  let t15;
  let t16;
  if ($[30] !== activityPage || $[31] !== activityTypeFilter || $[32] !== nftId) {
    t15 = () => {
      if (nftId) {
        let url = `${publicEnv.API_ENDPOINT}/api/transactions_memelab?id=${nftId}&page_size=${ACTIVITY_PAGE_SIZE}&page=${activityPage}`;
        bb62: switch (activityTypeFilter) {
          case TypeFilter.SALES:
            {
              url = url + "&filter=sales";
              break bb62;
            }
          case TypeFilter.TRANSFERS:
            {
              url = url + "&filter=transfers";
              break bb62;
            }
          case TypeFilter.AIRDROPS:
            {
              url = url + "&filter=airdrops";
              break bb62;
            }
          case TypeFilter.MINTS:
            {
              url = url + "&filter=mints";
              break bb62;
            }
          case TypeFilter.BURNS:
            {
              url = url + "&filter=burns";
            }
        }
        fetchUrl(url).then(response_3 => {
          setActivityTotalResults(response_3.count);
          setActivity(response_3.data);
        });
      }
    };
    t16 = [nftId, activityPage, activityTypeFilter];
    $[30] = activityPage;
    $[31] = activityTypeFilter;
    $[32] = nftId;
    $[33] = t15;
    $[34] = t16;
  } else {
    t15 = $[33];
    t16 = $[34];
  }
  useEffect(t15, t16);
  let t17;
  let t18;
  if ($[35] !== nftId) {
    t17 = () => {
      const fetchHistory = async function fetchHistory(url_0) {
        return fetchAllPages(url_0).then(response_4 => {
          setNftHistory(response_4);
        });
      };
      if (nftId) {
        const initialUrlHistory = `${publicEnv.API_ENDPOINT}/api/nft_history/${MEMELAB_CONTRACT}/${nftId}`;
        fetchHistory(initialUrlHistory);
      }
    };
    t18 = [nftId];
    $[35] = nftId;
    $[36] = t17;
    $[37] = t18;
  } else {
    t17 = $[36];
    t18 = $[37];
  }
  useEffect(t17, t18);
  let T0;
  let T1;
  let T2;
  let T3;
  let t19;
  let t20;
  let t21;
  let t22;
  let t23;
  if ($[38] !== activeTab || $[39] !== activity || $[40] !== activityPage || $[41] !== activityTotalResults || $[42] !== activityTypeFilter || $[43] !== capacitor || $[44] !== connectedProfile || $[45] !== country || $[46] !== fullscreenElementId || $[47] !== isFullScreenSupported || $[48] !== nft || $[49] !== nftBalance || $[50] !== nftHistory || $[51] !== nftId || $[52] !== nftMeta || $[53] !== originalMemes || $[54] !== originalMemesLoaded || $[55] !== searchParams || $[56] !== transactions || $[57] !== userLoaded) {
    const printContent = function printContent() {
      if (activeTab === MEME_FOCUS.ACTIVITY) {
        return printActivity();
      }
      if (activeTab === MEME_FOCUS.THE_ART) {
        return printTheArt();
      }
      if (activeTab === MEME_FOCUS.COLLECTORS) {
        return printHodlers();
      }
      if (activeTab === MEME_FOCUS.TIMELINE) {
        return printTimeline();
      }
      return <Container className="p-0"><Row className={connectedProfile ? styles.nftImagePadding : ""}>{[MEME_FOCUS.LIVE, MEME_FOCUS.YOUR_CARDS].includes(activeTab) && nft && <><Col xs={{
              span: 12
            }} sm={{
              span: 12
            }} md={{
              span: 6
            }} lg={{
              span: 6
            }} className={`${styles.nftImageWrapper} pt-2 pb-5`}><NFTImage nft={nft} animation={true} height={650} showBalance={true} /></Col>{activeTab === MEME_FOCUS.LIVE && <>{printLive()}</>}{activeTab === MEME_FOCUS.YOUR_CARDS && <>{printYourCards()}</>}</>}</Row><Row>{activeTab === MEME_FOCUS.LIVE && <>{printMemeReferences(originalMemes, "the-memes", originalMemesLoaded)}</>}{activeTab === MEME_FOCUS.YOUR_CARDS && <>{printYourCardsSub()}</>}</Row></Container>;
    };
    function printLive() {
      if (nft && nftMeta) {
        return <Col xs={{
          span: 12
        }} sm={{
          span: 12
        }} md={{
          span: 6
        }} lg={{
          span: 6
        }} className="pt-2"><Container className="p-0"><Row className="pt-3"><Col><h3>NFT</h3></Col></Row><Row><Col><Table bordered={false}><tbody><tr><td>Artist Name</td><td>{nft.artist}</td></tr><tr><td>Artist Profile</td><td><ArtistProfileHandle nft={nft} /></td></tr><tr><td>Collection</td><td><Link href={`/meme-lab/collection/${encodeURIComponent(nftMeta.metadata_collection.replaceAll(" ", "-"))}`}>{nftMeta.metadata_collection}</Link></td></tr>{nftMeta.website && <tr><td>Website</td><td>{nftMeta.website.split(" ").map(_temp2)}</td></tr>}<tr><td>Mint Date</td><td>{printMintDate(nft.mint_date)}</td></tr><NftPageStats nft={nft} /></tbody></Table></Col></Row><Row><Col><h3>Meme Collectors</h3></Col></Row><Row><Col><Table bordered={false} className={styles.hodlersTableLive}><tbody><tr><td>Edition Size</td><td className="text-right">{numberWithCommas(nftMeta.edition_size)}</td><td className="text-right">{nftMeta.edition_size_rank}/{nftMeta.collection_size}</td></tr>{nftMeta.burnt > 0 && <><tr><td><span className="d-flex align-items-center gap-2"><span>Burnt</span><FontAwesomeIcon icon={faFire} style={{
                              height: "22px",
                              color: "#c51d34"
                            }} /></span></td><td className="text-right">{numberWithCommas(nftMeta.burnt)}</td></tr><tr><td>Edition Size ex. Burnt</td><td className="text-right">{numberWithCommas(nftMeta.edition_size_not_burnt)}</td><td className="text-right">{nftMeta.edition_size_not_burnt_rank}/{nftMeta.collection_size}</td></tr></>}<tr><td>6529 Museum</td><td className="text-right">{numberWithCommas(nftMeta.museum_holdings)}</td><td className="text-right">{nftMeta.museum_holdings_rank}/{nftMeta.collection_size}</td></tr><tr><td>Edition Size ex.{nftMeta.burnt > 0 && " Burnt and"} 6529 Museum</td><td className="text-right">{numberWithCommas(nftMeta.edition_size_cleaned)}</td><td className="text-right">{nftMeta.edition_size_cleaned_rank}/{nftMeta.collection_size}</td></tr><tr><td>Collectors</td><td className="text-right">{numberWithCommas(nftMeta.hodlers)}</td><td className="text-right">{nftMeta.hodlers_rank}/{nftMeta.collection_size}</td></tr><tr><td>% Unique</td><td className="text-right">{Math.round(nftMeta.percent_unique * 100 * 10) / 10}%</td><td className="text-right">{nftMeta.percent_unique_rank}/{nftMeta.collection_size}</td></tr>{nftMeta.burnt > 0 && <tr><td>% Unique ex. Burnt</td><td className="text-right">{Math.round(nftMeta.percent_unique_not_burnt * 100 * 10) / 10}%</td><td className="text-right">{nftMeta.percent_unique_not_burnt_rank}/{nftMeta.collection_size}</td></tr>}<tr><td>% Unique ex.{nftMeta.burnt > 0 && " Burnt and"} 6529 Museum</td><td className="text-right">{Math.round(nftMeta.percent_unique_cleaned * 100 * 10) / 10}%</td><td className="text-right">{nftMeta.percent_unique_cleaned_rank}/{nftMeta.collection_size}</td></tr></tbody></Table></Col></Row>{nft.has_distribution ? <Row className="pt-3 pb-3"><Col><Link href={`/meme-lab/${nft.id}/distribution`}>Distribution Plan</Link></Col></Row> : ""}{nftBalance > 0 && <Row className="pt-3"><Col><h3 className="font-color">You Own {nftBalance} edition{nftBalance > 1 && "s"}</h3></Col></Row>}{(!capacitor.isIos || country === "US") && <Row className="pt-4"><Col><NFTMarketplaceLinks contract={nft.contract} id={nft.id} /></Col></Row>}</Container></Col>;
      }
    }
    let t24;
    if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = function getTokenCount(transactions_0) {
        let count = 0;
        [...transactions_0].map(e => {
          count = count + e.token_count;
          count;
        });
        return count;
      };
      $[67] = t24;
    } else {
      t24 = $[67];
    }
    const getTokenCount = t24;
    function printYourCardsSub() {
      return <>{transactions.length > 0 && <><Row className="pt-4"><Col><h3>Your Transaction History</h3></Col></Row><Row className={`pt-4 ${styles.transactionsScrollContainer}`}><Col><Table bordered={false} className={styles.transactionsTable}><tbody>{transactions.map(_temp3)}</tbody></Table></Col></Row></>}</>;
    }
    function printYourCards() {
      const firstAcquired = [...transactions].sort(_temp4)[0];
      const airdropped = transactions.filter(_temp5);
      const walletObjects_0 = connectedProfile?.wallets ?? [];
      const wallets_0 = walletObjects_0.map(_temp6);
      const transferredIn = wallets_0.length === 0 ? [] : transactions.filter(t_0 => !areEqualAddresses(t_0.from_address, NULL_ADDRESS) && wallets_0.some(w_4 => areEqualAddresses(t_0.to_address, w_4)) && t_0.value === 0);
      const transferredOut = wallets_0.length === 0 ? [] : transactions.filter(t_1 => wallets_0.some(w_5 => areEqualAddresses(t_1.from_address, w_5)) && t_1.value === 0);
      const bought = wallets_0.length === 0 ? [] : transactions.filter(t_2 => wallets_0.some(w_6 => areEqualAddresses(t_2.to_address, w_6)) && t_2.value > 0);
      let boughtSum = 0;
      bought.map(b_0 => {
        boughtSum = boughtSum + b_0.value;
        boughtSum;
      });
      const sold = wallets_0.length === 0 ? [] : transactions.filter(t_3 => wallets_0.some(w_7 => areEqualAddresses(t_3.from_address, w_7)) && t_3.value > 0);
      let soldSum = 0;
      sold.map(b_1 => {
        soldSum = soldSum + b_1.value;
        soldSum;
      });
      return <Col xs={{
        span: 12
      }} sm={{
        span: 12
      }} md={{
        span: 6
      }} lg={{
        span: 6
      }}><Container className="p-0"><Row>{wallets_0.length === 0 && <Row className="pt-2"><Col><h4>Connect your wallet to view your cards.</h4></Col></Row>}{nftBalance === 0 && wallets_0.length > 0 && nft && userLoaded && <Row className="pt-2"><Col><h3>You don't own any editions of Card {nft.id}</h3></Col></Row>}{transactions.length > 0 && wallets_0.length > 0 && nftBalance > 0 && nft && <><Row className="pt-2"><Col xs={{
                  span: 12
                }} sm={{
                  span: 12
                }} md={{
                  span: 12
                }} lg={{
                  span: 8
                }}><Table bordered={false}><tbody><tr className={`${styles.overviewColumn}`}><td>Cards</td><td className="text-right">{`x${nftBalance}`}</td></tr></tbody></Table></Col></Row><Row className="mb-2"><Col><TransferSingle collectionType={CollectedCollectionType.MEMELAB} contractType={ContractType.ERC1155} contract={MEMELAB_CONTRACT} tokenId={nft.id} max={nftBalance} title={nft?.name ?? `Meme Lab #${nft?.id}`} thumbUrl={nft?.thumbnail} /></Col></Row></>}{transactions.length > 0 && <><Row className="pt-2 pb-2"><Col><h3>Overview</h3></Col></Row><Row className={`pb-2 ${styles.overviewColumn}`}><Col>First acquired{" "}{printMintDate(new Date(firstAcquired.transaction_date))}</Col></Row>{airdropped.length > 0 && <Row className={`pt-1 ${styles.overviewColumn}`}><Col>{getTokenCount(airdropped)} card{getTokenCount(airdropped) > 1 && "s"} airdropped</Col></Row>}{bought.length > 0 && <Row className={`pt-1 ${styles.overviewColumn}`}><Col>{getTokenCount(bought)} card{getTokenCount(bought) > 1 && "s"} bought for {boughtSum}{" "}ETH</Col></Row>}{transferredIn.length > 0 && <Row className={`pt-1 ${styles.overviewColumn}`}><Col>{getTokenCount(transferredIn)} card{getTokenCount(transferredIn) > 1 && "s"} transferred in</Col></Row>}{sold.length > 0 && <Row className={`pt-1 ${styles.overviewColumn}`}><Col>{getTokenCount(sold)} card{getTokenCount(sold) > 1 && "s"} sold for {soldSum} ETH</Col></Row>}{transferredOut.length > 0 && <Row className={`pt-1 ${styles.overviewColumn}`}><Col>{getTokenCount(transferredOut)} card{getTokenCount(transferredOut) > 1 && "s"} transferred out</Col></Row>}</>}</Row></Container></Col>;
    }
    let t25;
    if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = function carouselHandlerSlide(event) {
        if (event === 0) {
          setFullscreenElementId("the-art-fullscreen-animation");
        } else {
          setFullscreenElementId("the-art-fullscreen-img");
        }
      };
      $[68] = t25;
    } else {
      t25 = $[68];
    }
    const carouselHandlerSlide = t25;
    function printTheArt() {
      if (nft && nftMeta) {
        return <><Container className="p-0"><Row className="position-relative">{isFullScreenSupported && <FontAwesomeIcon icon={faExpandAlt} className={styles.fullScreen} onClick={() => fullscreenElementId && enterArtFullScreen(fullscreenElementId)} />}{nft.animation ? <Carousel className={styles.memesCarousel} interval={null} indicators={false} wrap={false} onSlide={carouselHandlerSlide}><Carousel.Item className="text-center"><div className="pt-4 pb-3">{nft.metadata.animation_details.format}</div><NFTImage nft={nft} animation={true} height={650} transparentBG={true} showOriginal={true} showBalance={false} id="the-art-fullscreen-animation" /></Carousel.Item><Carousel.Item className="text-center"><div className="pt-4 pb-3">{nft.metadata.image_details.format}</div><NFTImage nft={nft} animation={false} height={650} transparentBG={true} showOriginal={true} showBalance={false} id="the-art-fullscreen-img" /></Carousel.Item></Carousel> : <><Col xs={12} className="text-center pb-5">{nft.metadata.image_details.format}</Col><NFTImage nft={nft} animation={false} height={650} showBalance={false} transparentBG={true} showOriginal={true} id="the-art-fullscreen-img" /></>}</Row></Container><Container className="pt-5 pb-3"><Row><Col><Container><Row><Col><Row><Col><h3>Arweave Links</h3></Col></Row><Row><Col className="tw-flex tw-items-center tw-gap-1"><span>{nft.metadata.image_details.format}</span><Link className={styles.arweaveLink} href={nft.metadata.image} target="_blank" rel="noopener noreferrer">{nft.metadata.image}</Link><Download href={nft.metadata.image} name={nft.name} extension={nft.metadata.image_details.format} /></Col></Row>{(nft.metadata.animation || nft.metadata.animation_url) && <Row className="pt-3"><Col className="tw-flex tw-items-center tw-gap-1"><span>{nft.metadata.animation_details.format}</span><Link className={styles.arweaveLink} href={nft.metadata.animation ? nft.metadata.animation : nft.metadata.animation_url} target="_blank" rel="noopener noreferrer">{nft.metadata.animation ? nft.metadata.animation : nft.metadata.animation_url}</Link><Download href={nft.metadata.animation ? nft.metadata.animation : nft.metadata.animation_url} name={nft.name} extension={nft.metadata.animation_details.format} /></Col></Row>}</Col></Row></Container></Col></Row></Container><Container className="pt-3 pb-3"><Row><Col xs={{
                span: 12
              }} sm={{
                span: 6
              }} md={{
                span: 6
              }} lg={{
                span: 6
              }}><Container><Row><Col><h3>Card Details</h3></Col></Row><Row><Col><Table bordered={false}><tbody><tr><td>Edition Size</td><td>{nft.supply}</td></tr><tr><td>Collection</td><td>{nft.collection}</td></tr><tr><td>Artist Name</td><td>{nft.artist}</td></tr><tr><td>Artist Profile</td><td><ArtistProfileHandle nft={nft} /></td></tr><tr><td>Mint Date</td><td>{printMintDate(nft.mint_date)}</td></tr><tr><td>File Type</td><td>{getFileTypeFromMetadata(nft.metadata)}</td></tr><tr><td>Dimensions</td><td>{getDimensionsFromMetadata(nft.metadata)}</td></tr></tbody></Table></Col></Row></Container></Col>{nft.metadata.attributes.some(_temp7) && <Col xs={{
                span: 12
              }} sm={{
                span: 6
              }} md={{
                span: 6
              }} lg={{
                span: 6
              }}><Container><Row><Col><h3>References</h3></Col></Row><Row><Col><Table><tbody>{nft.metadata.attributes.filter(_temp8).map(_temp9)}</tbody></Table></Col></Row></Container></Col>}</Row></Container><Container className="pt-3 pb-3"><Row><Col><Container><Row><Col><h3>Card Description</h3></Col></Row><Row><Col dangerouslySetInnerHTML={{
                      __html: parseNftDescriptionToHtml(nft.description)
                    }} /></Row></Container></Col></Row></Container><Container className="pt-3 pb-3"><Row><Col><Container><Row><Col><h3>Properties</h3></Col></Row><Row><Col><NFTAttributes attributes={nft.metadata.attributes} /></Col></Row></Container></Col></Row></Container></>;
      }
    }
    function printHodlers() {
      if (nft && nftId) {
        return <Row className="p-0"><Col><MemeLabLeaderboard contract={nft.contract} nftId={parseInt(nftId)} /></Col></Row>;
      }
    }
    function printTimeline() {
      return <Container className="pt-3 pb-5 no-padding"><Row><Col xs={12} md={{
            span: 10,
            offset: 1
          }}>{nft && <Timeline nft={nft} steps={nftHistory} />}</Col></Row></Container>;
    }
    function printActivity() {
      return <Container className="p-0">{nft && <><Row className="pt-2"><Col><h3>Card Volumes</h3></Col></Row><Row className="pt-2"><Col><Table className="text-center"><thead><tr><th>24 Hours</th><th>7 Days</th><th>30 Days</th><th>All Time</th></tr></thead><tbody className="pt-3"><tr><td>{nft.total_volume_last_24_hours > 0 ? `${numberWithCommas(Math.round(nft.total_volume_last_24_hours * 100) / 100)} ETH` : "N/A"}</td><td>{nft.total_volume_last_7_days > 0 ? `${numberWithCommas(Math.round(nft.total_volume_last_7_days * 100) / 100)} ETH` : "N/A"}</td><td>{nft.total_volume_last_1_month > 0 ? `${numberWithCommas(Math.round(nft.total_volume_last_1_month * 100) / 100)} ETH` : "N/A"}</td><td>{nft.total_volume > 0 ? `${numberWithCommas(Math.round(nft.total_volume * 100) / 100)} ETH` : "N/A"}</td></tr></tbody></Table></Col></Row></>}<Row className="pt-3"><Col className="d-flex align-items-center" xs={{
            span: 7
          }} sm={{
            span: 7
          }} md={{
            span: 9
          }} lg={{
            span: 10
          }}><h3>Card Activity</h3></Col><Col xs={{
            span: 5
          }} sm={{
            span: 5
          }} md={{
            span: 3
          }} lg={{
            span: 2
          }}><Dropdown className={styles.activityFilterDropdown} drop="down-centered"><Dropdown.Toggle>Filter: {activityTypeFilter}</Dropdown.Toggle><Dropdown.Menu>{Object.values(TypeFilter).map(filter => <Dropdown.Item key={`nft-activity-${filter}`} onClick={() => {
                  setActivityPage(1);
                  setActivityTypeFilter(filter);
                }}>{filter}</Dropdown.Item>)}</Dropdown.Menu></Dropdown></Col></Row>{activity.length > 0 ? <Row className={`pt-2 ${styles.transactionsScrollContainer}`}><Col><Table bordered={false} className={styles.transactionsTable}><tbody>{activity.map(tr_0 => <LatestActivityRow tr={tr_0} nft={nft} key={`${tr_0.from_address}-${tr_0.to_address}-${tr_0.transaction}-${tr_0.token_id}`} />)}</tbody></Table></Col></Row> : <Row><Col><NothingHereYetSummer /></Col></Row>}{activity.length > 0 && <Row className="text-center pt-2 pb-3"><Pagination page={activityPage} pageSize={ACTIVITY_PAGE_SIZE} totalResults={activityTotalResults} setPage={function (newPage) {
            setActivityPage(newPage);
            window.scrollTo(0, 0);
          }} /></Row>}</Container>;
    }
    T3 = Container;
    t22 = true;
    t23 = styles.mainContainer;
    T2 = Row;
    T1 = Col;
    T0 = Container;
    t19 = "pt-4 pb-4";
    if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <Row><Col><h1>Meme Lab</h1></Col></Row>;
      $[69] = t20;
    } else {
      t20 = $[69];
    }
    t21 = nftMeta && nft && <><Row className="pt-2"><Col className="d-flex"><NftNavigation nftId={nft.id} path="/meme-lab" startIndex={1} endIndex={nftMeta.collection_size} params={searchParams} /></Col></Row><Row className="pt-2"><Col><h2 className="float-left">Card {nft.id} - </h2><h2 className="float-left">{nft.name}</h2></Col></Row><Row className="pt-3 pb-3"><Col className="tw-flex tw-gap-3 tw-items-center tw-flex-wrap">{MEME_TABS.map(tab => <TabButton key={`${nft.id}-${nft.contract}-${tab.focus}-tab`} tab={tab} activeTab={activeTab} setActiveTab={setActiveTab} />)}</Col></Row>{printContent()}</>;
    $[38] = activeTab;
    $[39] = activity;
    $[40] = activityPage;
    $[41] = activityTotalResults;
    $[42] = activityTypeFilter;
    $[43] = capacitor;
    $[44] = connectedProfile;
    $[45] = country;
    $[46] = fullscreenElementId;
    $[47] = isFullScreenSupported;
    $[48] = nft;
    $[49] = nftBalance;
    $[50] = nftHistory;
    $[51] = nftId;
    $[52] = nftMeta;
    $[53] = originalMemes;
    $[54] = originalMemesLoaded;
    $[55] = searchParams;
    $[56] = transactions;
    $[57] = userLoaded;
    $[58] = T0;
    $[59] = T1;
    $[60] = T2;
    $[61] = T3;
    $[62] = t19;
    $[63] = t20;
    $[64] = t21;
    $[65] = t22;
    $[66] = t23;
  } else {
    T0 = $[58];
    T1 = $[59];
    T2 = $[60];
    T3 = $[61];
    t19 = $[62];
    t20 = $[63];
    t21 = $[64];
    t22 = $[65];
    t23 = $[66];
  }
  let t24;
  if ($[70] !== T0 || $[71] !== t19 || $[72] !== t20 || $[73] !== t21) {
    t24 = <T0 className={t19}>{t20}{t21}</T0>;
    $[70] = T0;
    $[71] = t19;
    $[72] = t20;
    $[73] = t21;
    $[74] = t24;
  } else {
    t24 = $[74];
  }
  let t25;
  if ($[75] !== T1 || $[76] !== t24) {
    t25 = <T1>{t24}</T1>;
    $[75] = T1;
    $[76] = t24;
    $[77] = t25;
  } else {
    t25 = $[77];
  }
  let t26;
  if ($[78] !== T2 || $[79] !== t25) {
    t26 = <T2>{t25}</T2>;
    $[78] = T2;
    $[79] = t25;
    $[80] = t26;
  } else {
    t26 = $[80];
  }
  let t27;
  if ($[81] !== T3 || $[82] !== t22 || $[83] !== t23 || $[84] !== t26) {
    t27 = <T3 fluid={t22} className={t23}>{t26}</T3>;
    $[81] = T3;
    $[82] = t22;
    $[83] = t23;
    $[84] = t26;
    $[85] = t27;
  } else {
    t27 = $[85];
  }
  return t27;
}
function _temp9(a_1) {
  return <tr key={`${a_1.trait_type}-${a_1.value}`}><td>{a_1.trait_type}</td><td>{a_1.value}</td></tr>;
}
function _temp8(a_0) {
  return a_0.trait_type.startsWith("Meme Card Reference") && a_0.value != "None" && a_0.value;
}
function _temp7(a_2) {
  return a_2.trait_type.startsWith("Meme Card Reference") && a_2.value != "None" && a_2.value;
}
function _temp6(w_3) {
  return w_3.wallet;
}
function _temp5(t) {
  return t.value === 0 && areEqualAddresses(t.from_address, NULL_ADDRESS);
}
function _temp4(a, b) {
  return a.transaction_date > b.transaction_date ? 1 : -1;
}
function _temp3(tr) {
  return <LatestActivityRow tr={tr} key={`${tr.from_address}-${tr.to_address}-${tr.transaction}-${tr.token_id}`} />;
}
function _temp2(w_2) {
  return <Fragment key={`meta-website-${w_2}`}><Link href={addProtocol(w_2)} target="_blank" rel="noopener noreferrer">{w_2}</Link>  </Fragment>;
}
function _temp(w) {
  return w.wallet;
}